export interface Bonus {
  title: string
  description: string
  value: string
  cover: string
}

export const bonuses: Bonus[] = [
  {
    title: 'Das Jahreszeiten-Paket',
    description:
      '40 fertige Projekte für Weihnachten, Ostern, Muttertag und Schuljahresende.',
    value: '38 €',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/173fd01b-994a-43b5-9fc1-1fd86b9a3e4e.jpg',
  },
  {
    title: 'Die Zeichenschule',
    description:
      '50 Motive Schritt für Schritt — vom Strichmännchen bis zum Porträt.',
    value: '27 €',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/08072612-a8a7-4d64-88b8-8bbcdf7055d6.jpg',
  },
  {
    title: 'Das Poster-Paket',
    description:
      '10 Poster fürs Klassenzimmer — einmal aufhängen, das ganze Jahr nutzen.',
    value: '27 €',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/e65de957-3660-4383-bdf0-14fbf7c5fd1a.jpg',
  },
  {
    title: 'Die Impulskarten',
    description: '50 Karten zum Ausschneiden für alle, die früher fertig sind.',
    value: '19 €',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/561d2e86-a0bd-4715-bb85-e69eba309d61.jpg',
  },
  {
    title: 'Ausstellung & Elternabend',
    description:
      'Vom Stapel Blätter zur fertigen Ausstellung — inklusive aller Vorlagen.',
    value: '19 €',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/3f3c62e3-12a8-4dbc-8fa0-f7f687c18136.jpg',
  },
]
